import React from "react";

import { FaceIcon } from "../../assets";
import "./ProjectCard.scss";

export type ProjectCardProps = {
  cx?: string;
  title: string;
  isInput: boolean;
  handleBlur: any;
  rightClick?: any;
  isNew?: boolean;
  handleKeyUp: any;
  handleChange: any;
  category: string;
  sentiment?:
    | "positive-1"
    | "positive-2"
    | "positive-3"
    | "neutral"
    | "negative-1"
    | "negative-2"
    | "negative-3"
    | "default";
  onClick?: any;
};

/**
 *
 * @param {string?} cx
 * @param {string} title
 * @param {string} category
 * @param handleBlur : useState[1]
 * @param rightClick
 * @param isInput : useState[0]
 * @param handleKeyUp {any} - 타이틀 수정모드일 때 엔터버튼을 누르면 생기는 이벤트.
 * @param handleChange
 * @param isNew
 * @param sentiment
 * @param onClick
 * @constructor
 */
export const ProjectCard: React.FC<ProjectCardProps> = ({
  cx = "",
  title,
  category,
  handleBlur,
  rightClick,
  isInput,
  handleKeyUp,
  handleChange,
  isNew = false,
  sentiment = "default",
  onClick,
}) => {
  return (
    <div
      className={`ProjectCard ${cx} ${isInput ? "inputMode" : ""}`}
      onContextMenu={rightClick}
      onClick={onClick}
    >
      <FaceIcon cx={sentiment} />
      <div className={"title"}>
        {isInput ? (
          <ProjectCardTitle
            sentiment={sentiment}
            isInput={isInput}
            isNew={isNew}
            title={title}
            handleBlur={handleBlur}
            handleKeyUp={handleKeyUp}
            handleChange={handleChange}
            category={category}
          />
        ) : (
          <div className={"title-text ellipsis"}>{title}</div>
        )}
      </div>
      <span className={"category"}>{category}</span>
    </div>
  );
};

class ProjectCardTitle extends React.Component<ProjectCardProps> {
  private inputRef: React.RefObject<HTMLInputElement>;

  constructor(props: ProjectCardProps) {
    super(props);
    this.inputRef = React.createRef();
  }

  componentDidMount() {
    this.inputRef.current?.select();
  }

  render() {
    const { isNew, title, handleBlur, handleKeyUp, handleChange } = this.props;
    return (
      <input
        type="text"
        className={"title-text"}
        placeholder={"New Project"}
        defaultValue={isNew ? "New Project #" : title}
        onKeyUp={(e) => {
          if (e.key === "Enter") {
            handleKeyUp(e);
          }
        }}
        onChange={(e) => handleChange(e)}
        onBlur={handleBlur}
        ref={this.inputRef}
      />
    );
  }
}
